export default {"src":"/_next/static/media/pick.e069b704.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};